import { render, staticRenderFns } from "./SignupStepTwo.vue?vue&type=template&id=1b8b1e9f"
import script from "./SignupStepTwo.vue?vue&type=script&lang=js"
export * from "./SignupStepTwo.vue?vue&type=script&lang=js"
import style0 from "./SignupStepTwo.vue?vue&type=style&index=0&id=1b8b1e9f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports